import React from 'react';
import { formatTemp, getWeatherIcon, formatTime } from '../../utils/weatherUtils';
import Icon from '../../utils/icons';
import './CurrentConditions.css';

function CurrentConditions({ data }) {
  if (!data) return null;

  const { city, country, current, condition, sunrise, sunset } = data;

  return (
    <div className="current-conditions">
      <div className="conditions-header">
        <h2 className="card-title">Current Conditions</h2>
        <span className="location-badge">
          <Icon name="mapPin" size={12} />
          {city}, {country}
        </span>
      </div>

      <div className="conditions-main">
        <div className="temperature-display">
          {condition?.icon && (
            <img
              src={getWeatherIcon(condition.icon, '4x')}
              alt={condition?.description || 'Weather'}
              className="main-weather-icon"
            />
          )}
          <div className="temperature-info">
            <span className="current-temp">{formatTemp(current?.temperature)}</span>
            <span className="feels-like">
              Feels like {formatTemp(current?.feels_like)}
            </span>
          </div>
        </div>

        <div className="condition-description">
          {condition?.description || 'N/A'}
        </div>
      </div>

      <div className="conditions-details">
        <div className="detail-row">
          <div className="detail">
            <Icon name="sunrise" size={20} className="detail-icon" />
            <div className="detail-content">
              <span className="detail-label">Sunrise</span>
              <span className="detail-value">{formatTime(sunrise)}</span>
            </div>
          </div>
          <div className="detail">
            <Icon name="sunset" size={20} className="detail-icon" />
            <div className="detail-content">
              <span className="detail-label">Sunset</span>
              <span className="detail-value">{formatTime(sunset)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CurrentConditions;